var richTypes = {
  Date: true,
  RegExp: true,
  String: true,
  Number: true
};
export default function diff(obj, newObj) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    cyclesFix: true
  };

  var _stack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var diffs = [];
  var isObjArray = Array.isArray(obj);

  var _loop = function _loop(key) {
    var objKey = obj[key];
    var path = isObjArray ? +key : key;

    if (!(key in newObj)) {
      diffs.push({
        type: "REMOVE",
        path: [path],
        oldValue: obj[key]
      });
      return "continue";
    }

    var newObjKey = newObj[key];
    var areObjects = typeof objKey === "object" && typeof newObjKey === "object";

    if (objKey && newObjKey && areObjects && !richTypes[Object.getPrototypeOf(objKey).constructor.name] && (!options.cyclesFix || !_stack.includes(objKey))) {
      var nestedDiffs = diff(objKey, newObjKey, options, options.cyclesFix ? _stack.concat([objKey]) : []);
      diffs.push.apply(diffs, nestedDiffs.map(function (difference) {
        difference.path.unshift(path);
        return difference;
      }));
    } else if (objKey !== newObjKey && !(areObjects && (isNaN(objKey) ? objKey + "" === newObjKey + "" : +objKey === +newObjKey))) {
      diffs.push({
        path: [path],
        type: "CHANGE",
        value: newObjKey,
        oldValue: objKey
      });
    }
  };

  for (var key in obj) {
    var _ret = _loop(key);

    if (_ret === "continue") continue;
  }

  var isNewObjArray = Array.isArray(newObj);

  for (var _key in newObj) {
    if (!(_key in obj)) {
      diffs.push({
        type: "CREATE",
        path: [isNewObjArray ? +_key : _key],
        value: newObj[_key]
      });
    }
  }

  return diffs;
}